import React, { useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import Dialog from './QuoteDialog';
import Button from '../../../shared/components/Button/Button';
import Input from '../../../shared/components/Input/Input';
import Select from '../../../shared/components/Select/Select';
import { lineFromServicePreset, quoteServicePresets } from '../quoteServiceCatalog';

export default function QuoteServicePresetPicker({ editor, disabled, onSelect, open: controlledOpen, onOpenChange, hideTrigger = false }) {
  const [internalOpen, setInternalOpen] = useState(false);
  const open = controlledOpen ?? internalOpen;
  const setOpen = onOpenChange || setInternalOpen;
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('all');
  const categories = useMemo(() => [...new Set(quoteServicePresets.map((item) => item.category))], []);
  const rows = useMemo(() => {
    const needle = query.trim().toLowerCase();
    return quoteServicePresets.filter((item) => (category === 'all' || item.category === category)
      && (!needle || `${item.category} ${item.label}`.toLowerCase().includes(needle)));
  }, [query, category]);

  const choose = (preset) => {
    onSelect(lineFromServicePreset(preset, editor));
    setOpen(false); setQuery('');
  };

  return <>
    {!hideTrigger && <Button disabled={disabled} onClick={() => setOpen(true)}>Ajouter depuis le catalogue</Button>}
    {open && createPortal(<Dialog open={open} onClose={() => setOpen(false)} title="Catalogue de prestations" size="large"
      actions={<Button onClick={() => setOpen(false)}>Fermer</Button>}>
        <div className="quote-service-catalog-modal">
          <p>Sélectionnez une prestation préremplie. La ligne restera ensuite entièrement modifiable.</p>
          <div className="quote-catalog-search-row">
            <Input fullWidth label="Rechercher une prestation" value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Nom ou catégorie…" />
            <Select fullWidth label="Catégorie" value={category} onChange={(event) => setCategory(event.target.value)} options={[{ value: 'all', label: 'Toutes les catégories' }, ...categories.map((item) => ({ value: item, label: item }))]} />
          </div>
          <div className="quote-service-catalog-list">{rows.map((preset) => <button type="button" key={preset.id} onClick={() => choose(preset)}><span><strong>{preset.label}</strong><small>{preset.category}</small></span><b>{preset.hours} h</b></button>)}{!rows.length && <p>Aucune prestation correspondante.</p>}</div>
        </div>
    </Dialog>, document.body)}
  </>;
}
